module.exports = __webpack_public_path__ + "img/ann_h.136cada8.png";